<template>
  <b-modal
    v-model="showModal"
    :title="transferTitle"
    centered
    no-close-on-backdrop
    @hide="closeDialog()"
  >
    <Form label-width="30%">
      <FormItem
        label="Алхам"
        v-show="mode != -1 && mode != 2 && mode != 22 && mode != 222"
      >
        <!-- <select @change="columnChange" class="form-control" :disabled="skipAfterColumnId!=0">
            <option :selected="transferModel.columnId==c.id?'selected':'false'" v-for="(c,i) in transferOptions.taskColumns" :key="i" :value="c.id">{{c.title}}</option>
          </select> -->
        <!-- {{transferModel.columnId}} -->
        <Select
          class="wd-100p"
          @change="columnChange"
          v-model="transferModel.columnId"
          :disabled="skipAfterColumnId != 0"
          v-if="mode == 888"
        >
          <Option
            v-for="c in transferModel.taskColumns"
            :key="c.id"
            :value="c.id"
            :label="c.title"
          ></Option>
        </Select>
        <Select
          class="wd-100p"
          @change="columnChange"
          v-model="transferModel.columnId"
          :disabled="skipAfterColumnId != 0"
          v-else
        >
          <Option
            v-for="(c, i) in transferOptions.taskColumns"
            :key="i"
            :value="c.id"
            :label="c.title"
          ></Option>
        </Select>
      </FormItem>
      <FormItem
        label="Хэрэглэгч"
        v-show="mode != -1 && mode != 2 && mode != 22 && mode != 222"
        v-if="!userZaavalSongohgui"
        multiple
      >
        <Select
        filterable 
          class="wd-100p"
          v-model="transferModel.users"
          multiple
          :disabled="
            task.objectTypeId == 465 ||
            task.objectTypeId == 467 ||
            task.objectTypeId == 468 ||
            task.objectTypeId == 479
          "
        >
          <Option
            v-for="(u, i) in columnUsers"
            :key="i"
            :value="u.userId"
            :label="u.fullName"
            
          ></Option>
        </Select>
      </FormItem>

      <FormItem
        label="Хугацаа"
        v-if="timeData.ready && mode != -1"
        :description="displayHHMM()"
      >
        <DatePicker
          v-model="timeData.colDate"
          type="datetime"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :value-format="'yyyy-MM-dd HH:mm:ss'"
          style="width: 100%"
        ></DatePicker>
      </FormItem>

      

      <FormItem label="Тайлбар" v-if="mode != 222">
        
        <input
          v-if="primaryTsoholt"
          v-model="transferModel.tsoholt"
          class="form-control"
        />
        <input
          v-else-if="mode == -1 || mode == 2 || mode == 22 || mode == 3"
          v-model="transferModel.tsoholt"
          class="form-control"
        />
      </FormItem>
      <FormItem
        label="Дуусгасан хугацаа"
        v-if="task.objectTypeId == 535"
        :description="displayHHMM()"
      >
        <DatePicker
          v-model="timeData.colDate"
          type="datetime"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :value-format="'yyyy-MM-dd HH:mm:ss'"
          style="width: 100%"
        ></DatePicker>
      </FormItem>
    </Form>
    <div class="alert alert-warning" role="alert" v-if="mode == 222">
      Дуусгасан сургалтыг дахин нээх гэж байна. Итгэлтэй байна уу?
    </div>

    <!-- <v-card> -->
    <!-- <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>{{transferTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar> -->

    <!-- <v-card-text class="px-3 py-3"> -->
    <!-- <v-select v-show="mode!=-1 && mode!=2" v-model="transferModel.columnId" v-on:change="columnChange" 
            :items="transferOptions.taskColumns" item-text="title" item-value="id" label="Алхам" outlined ></v-select>
          <v-select v-show="mode!=-1 && mode!=2" v-model="transferModel.users" chips multiple
            :items="columnUsers" item-text="fullName" item-value="userId" label="Хэрэглэгч" outlined ></v-select> -->
    <!-- <div v-if="timeData.ready && mode!=-1">



            <v-dialog ref="dialog" v-model="modal" :return-value.sync="timeData.colDate" persistent width="290px" >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="timeData.colDate"
                  :label="'Хугацаа ('+displayHHMM()+')'"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="timeData.colDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(timeData.colDate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>



          </div> -->
    <!-- <v-textarea v-if="primaryTsoholt" v-model="transferModel.tsoholt" label="Тайлбар" hint="Тайлбар бичнэ үү" ></v-textarea>
          <v-textarea v-else-if="mode==-1 || mode==2 || mode==3" v-model="transferModel.tsoholt" label="Тайлбар" hint="Тайлбар бичнэ үү" ></v-textarea> -->

    <!-- <template v-if="hasAcceptColumn && (mode == 0 || mode == 1)">
            <p class="text-center">Цохолт</p>
            <v-dialog ref="dialogTsoholt" v-model="modalTsoholt" :return-value.sync="hasAcceptTask.dueDate" persistent width="290px" >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="hasAcceptTask.dueDate"
                  label="Дуусах хугацаа"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="hasAcceptTask.dueDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalTsoholt = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dialogTsoholt.save(hasAcceptTask.dueDate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <template v-if="hasAcceptObjectType==157">
              <v-checkbox v-model="hasAcceptTask.isTender" label="Эргэж танилцуулах цохолттой эсэх"></v-checkbox>
              <v-textarea v-model="hasAcceptTask.taskDescEn" label="Удирдлагын заалт" hint="Удирдлагын заалт бичнэ үү" ></v-textarea>
            </template>
          </template> -->

    <!-- </v-card-text>
      </v-card> -->
    <div slot="modal-footer">
      <button
        @click="undoTask"
        class="btn btn-xs btn-outline-danger"
        v-show="(mode == 0 || mode == -1) && transferOptions.canReturnTask"
      >
        Буцаах
      </button>
      <button
        @click="ok(1)"
        class="btn btn-outline-primary btn-xs"
        v-show="mode == 0 || mode == 1"
      >
        Шилжүүлэх
      </button>
      <button
        @click="ok(0)"
        class="btn btn-xs btn-outline-success"
        v-show="(mode == 0 || mode == 2) && transferOptions.canFinishTask"
      >
        Дуусгах
      </button>
      <button
        @click="ok(22)"
        class="btn btn-xs btn-outline-primary"
        v-show="mode == 22 && transferOptions.canFinishTask"
      >
        Дуусгах &#38; Дүн боловсруулах
      </button>
      <button
        @click="ok(222)"
        class="btn btn-xs btn-outline-warning"
        v-show="mode == 222"
      >
        Нээх
      </button>
      <button
        @click="ok(888)"
        class="btn btn-xs btn-outline-success"
        v-show="mode == 888"
      >
        <template v-if="task.objectTypeId == 465">
          Бүртгэлтэй эмд бүртгэх
        </template>
        <template v-else-if="task.objectTypeId == 467"> Лиценз олгох </template>
        <template v-else-if="task.objectTypeId == 468">
          Тусгай зөвшөөрөл олгох
        </template>
        <template v-else-if="task.objectTypeId == 479">
          Дээж импортлох лиценз олгох
        </template>
      </button>
    </div>
  </b-modal>
</template>
<script>
import { getUserInColumn, beforeUndo, undoTask } from "@/api/column";
import {
  getInheritedTask,
  postInheritedTask,
  moveTaskToColumn,
} from "@/api/task";
import { request } from "@/api/all";
import { mapActions } from "vuex";
const moment = require("moment");
import { Form, FormItem, DatePicker, Select, Option } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
export default {
  components: { Form, FormItem, DatePicker, Select, Option },
  props: {
    id: {
      type: Number,
      default: () => 0,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    mode: {
      type: Number,
      default: () => 0,
      /*
        0  => default huuchnaara bugd haragdana
        1  => shiljuuleh
        -1 => butsaah
        2  => duusgah
        888=> ajil hereg solih
      */
    },
    task: {
      type: Object,
      default: () => false,
    },
    transferOptions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      transferTitle: "",
      columnDeparts: [],
      columnUsers: [],
      timeData: {
        ready: false,
        colDate: "",
        minute: 0,
        nowDate: "",
      },

      taskColumns: [],
      canFinishTask: false,
      skipAfterColumnId: 0,
      primaryTsoholt: true,
      hasAcceptColumn: false,
      hasAcceptObjectType: 0,

      transferModel: {
        taskDone: false,
        projectId: 0,
        columnId: null,
        users: [],
        perc: 0,
        execution: "",
        tsoholt: "",
      },

      modal: false,
      modalTsoholt: false,

      getInheritedRaw: {},
      hasAcceptTask: {
        taskDescEn: "",
        dueDate: "",
        isTender: false,
      },
      showModal: false,
      userZaavalSongohgui: false,
    };
  },
  methods: {
    ...mapActions(["handleSnackbar"]),
    displayHHMM() {
      var diff = Math.abs(
        new Date(this.timeData.colDate) - new Date(this.timeData.nowDate)
      );
      var minutes = Math.floor(diff / 1000 / 60);

      let rv = "";

      if (minutes > 60) {
        if (minutes > 1440) {
          rv =
            Math.floor(minutes / (24 * 60)) + "өдөр " + (minutes % 24) + "цаг ";
        } else {
          rv = Math.floor(minutes / 60) + "цаг " + (minutes % 60) + "мин";
        }
      } else {
        rv = minutes + "мин";
      }

      return rv;
    },
    init() {
      this.showModal = true;
      //console.log('this.mode', this.mode);
      if (this.mode == -1) {
        this.transferTitle = "Буцаах";
      } else if (this.mode == 1) {
        this.transferTitle = "Шилжүүлэх";
      } else if (this.mode == 2) {
        this.transferTitle = "Дуусгах";
      } else if (this.mode == 222) {
        this.transferTitle = "Нээх";
      } else if (this.mode == 888) {
        let filterOt = 0;
        if (this.task.objectTypeId == 465) {
          filterOt = 472;
        } else if (this.task.objectTypeId == 467) {
          filterOt = 477;
        } else if (this.task.objectTypeId == 468) {
          filterOt = 476;
        } else if (this.task.objectTypeId == 479) {
          filterOt = 481;
        }

        request({
          api: { method: "get", url: "Task/GetSharedToFirstColumnProjects" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            let filteredProjs = res.data.projects.filter(
              (x) => x.ot == filterOt
            );
            if (filteredProjs.length > 0) {
              this.transferModel.projectId = filteredProjs[0].id;
              request({
                params: { projectId: this.transferModel.projectId },
                api: { method: "get", url: "Column/GetColumnListByProjectId" },
                store: this.$store,
              }).then((res) => {
                if (res != false) {
                  if (res.data.columns.length > 0) {
                    this.transferModel.taskColumns = res.data.columns;
                    this.transferModel.columnId = res.data.columns[0].id;
                    this.$nextTick(() => {
                      this.columnChange(res.data.columns[0].id);
                    });
                    //
                  }
                }
              });
            }
          }
        });
      }
      //# 2019-11-18 batlah alham tohirgoog alhmiin tohirgoond settldeg bolsontoi holbootoi nemegdev
      //# setleh yed 2 baganiig l iim tohirgootoi bna gej uzeed batalh alham len bnu gedgeer yavav
      let _acceptColumn = this.transferOptions.taskColumns.filter(
        (x) => x.settingFlag == 1 && x.direction == 1
      );

      let _skipColumn = this.transferOptions.taskColumns.filter(
        (x) => x.skipAfterColumnId != 0 && x.direction == 1
      );
      if (_skipColumn.length > 0) {
        let _ochihColumn = this.transferOptions.taskColumns.filter(
          (x) => x.id == _skipColumn[0].skipAfterColumnId
        );
        if (_ochihColumn.length > 0) {
          if (_ochihColumn[0].settingFlag == 4) {
            this.userZaavalSongohgui = true;
          }
        }
        this.skipAfterColumnId = _skipColumn[0].skipAfterColumnId;
        this.transferModel.columnId = this.skipAfterColumnId;
        this.columnChange(this.transferModel.columnId);
      }

      if (_acceptColumn.length > 0) {
        this.hasAcceptColumn = true;
        this.hasAcceptObjectType = this.task.objectTypeId;
        if (this.task.objectTypeId == 157) {
          this.primaryTsoholt = false;
        }
        getInheritedTask({
          params: { id: this.task.id },
          store: this.$store,
        }).then((res) => {
          //# res !=false nuhtsul bhgui bsan 2019-11-18 nd nemev
          if (res != false) {
            //console.log(res.data.task)
            this.hasAcceptTask = res.data.task;
            this.hasAcceptTask.dueDate = this.hasAcceptTask.dueDate.substr(
              0,
              10
            );
            this.hasAcceptReady = true;
          }
        });
      }
    },
    columnChange(e) {
      //console.log(e);
      this.canFinishTask = false;

      this.transferModel.users = [];

      getUserInColumn({
        params: { columnId: e },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          //console.log(res);
          this.columnDeparts = res.data.departs;
          this.columnUsers = res.data.users;

          //this.timeData.colDate = res.data.colDate;
          //this.timeData.colDate = res.data.colDate.substr(0, 10);
          this.timeData.colDate = moment(res.data.colDate).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.timeData.minute = res.data.minute;
          this.timeData.nowDate = res.data.nowDate;
          this.timeData.ready = true;
//console.log(this.columnUsers.length)

          //mnuac addist yed 
          if(this.columnUsers.length>0 && this.task.objectTypeId == 533 && e!=34093){
            this.columnUsers= this.columnUsers.filter(x=>x.departId==this.$store.state.user.userInfo.departId)
            //console.log('step 2', this.$store.state.user.userInfo.departId);
          }


          if (this.columnUsers.length > 0) {
            let uids = this.columnUsers
              .filter((u) => u.flag == 1)
              .map(function (u) {
                return u.userId;
              });
            if (uids.length > 0) {
              //console.log(uids);
              this.transferModel.users = uids;
            }

            if (
              this.transferModel.users.filter(
                (x) => x == this.$store.state.user.userId
              ).length == 0
            ) {
              //console.log("this1")
              if (
                this.columnUsers.filter(
                  (x) => x.userId == this.$store.state.user.userId
                ).length > 0
              ) {
                //console.log("this2")
                this.transferModel.users.push(this.$store.state.user.userId);
              }
            }

            // else {
            //   this.columnUsers[0].userId;
            // }
          }
        }
      });
    },
    userChange() {
      //console.log(e.target.value);
    },
    clearModel() {
      this.transferProject = false;
      this.transferModel.taskDone = false;
      this.transferModel.columnId = null;
      this.transferModel.users = [];
      this.transferModel.perc = 0;
      this.transferModel.tsoholt = "";
      this.transferModel.execution = "";
      this.transferModel.execution = "";
    },
    closeDialog(trsnfrd) {
      //this.clearModel();
      this.showModal = false;
      //console.error("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
      if (trsnfrd) this.$emit("on-transfered");
      else this.$emit("on-hide");
    },
    undoTask() {
      if (this.transferModel.tsoholt != "") {
        beforeUndo({ params: { id: this.task.id }, store: this.$store }).then(
          (res) => {
            if (res != false) {
              undoTask({
                params: {
                  id: this.task.id,
                  tsoholt: this.transferModel.tsoholt,
                },
                store: this.$store,
              }).then((res) => {
                if (res != false) {
                  this.closeDialog(true);
                }
              });
            }
          }
        );
      } else {
        this.$bvToast.toast(`Тайлбар бичнэ үү !`, {
          title: "Алдаа",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger",
          toaster: "b-toaster-bottom-left",
        });
      }
    },
    ok(mode) {
      let errs = [];
      if (mode == 0 || mode == 22) {
        if (this.transferModel.tsoholt == "") {
          this.$bvToast.toast(`дуусгах тайлбар бичнэ үү !`, {
            title: "Алдаа",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "danger",
            toaster: "b-toaster-bottom-left",
          });
        } else this.transferModel.taskDone = true;
      }

      if (mode == 1) {
        if (this.transferModel.columnId <= 0 && !this.transferModel.taskDone) {
          this.$bvToast.toast(`Алхам сонгоно уу !`, {
            title: "Алдаа",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "danger",
            toaster: "b-toaster-bottom-left",
          });
        }

        if (
          this.transferModel.users.length <= 0 &&
          !this.transferModel.taskDone &&
          !this.userZaavalSongohgui
        ) {
          this.$bvToast.toast(`Хэрэглэгч сонгоно уу !`, {
            title: "Алдаа",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "danger",
            toaster: "b-toaster-bottom-left",
          });
        }
      }

      if (errs.length == 0) {
        //console.log("todo here");
        //   if (this.transferProject && !this.transferModel.taskDone) {
        //     changeTaskProject({
        //       projectId: this.transferingProId,
        //       taskId: this.id,
        //       columnId: this.transferModel.columnId,
        //       users: this.transferModel.users,
        //       //perc: this.transferModel.perc,
        //       //execution: this.transferModel.execution
        //       tsoholt: this.transferModel.tsoholt,
        //       date: this.timeData.colDate
        //     }).then(res => {
        //       if (res != false) {
        //         this.$emit("on-transfered", { id: this.id });
        //         this.$emit("on-task-posted", { taskId: this.id });
        //       }
        //     });
        //   } else {
        if (mode == 888) {
          request({
            data: {
              projectId: this.transferModel.projectId,
              taskId: this.id,
              columnId: this.transferModel.columnId,
              users: this.transferModel.users,
              tsoholt: this.transferModel.tsoholt,
              //date: this.timeData.colDate
            },
            store: this.$store,
            api: {
              method: "POST",
              url: "Task/ChangeTaskProject",
            },
          }).then((res) => {
            if (res != false) {
              this.showModal = false;
              this.$emit("on-project-changed");

              this.$bvToast.toast(`Бүртгэлд амжилттай бүртгэлээ.`, {
                title: "Амжилттай",
                autoHideDelay: 5000,
                appendToast: true,
                variant: "success",
                toaster: "b-toaster-bottom-left",
              });
            }
          });
        } else if (mode == 22) {
          if (confirm("Дүн боловсруулахдаа итгэлтэй байна уу?")) {
            request({
              data: { id: this.id, completedDesc: this.transferModel.tsoholt },
              api: { method: "POST", url: "v2/Learn/CompleteCourse" },
              store: this.$store,
            }).then((res) => {
              if (res != false) {
                this.$bvToast.toast(`Амжилттай дуусгалаа`, {
                  title: "Мэдэгдэл",
                  autoHideDelay: 5000,
                  appendToast: true,
                  variant: "success",
                  toaster: "b-toaster-bottom-left",
                });
                this.closeDialog();
              }
            });
          }
        } else if (mode == 222) {
          request({
            data: { id: this.id },
            api: { method: "POST", url: "v2/Learn/UnCompleteCourse" },
            store: this.$store,
          }).then((res) => {
            if (res != false) {
              this.$bvToast.toast(`Амжилттай дуусгалаа`, {
                title: "Мэдэгдэл",
                autoHideDelay: 5000,
                appendToast: true,
                variant: "success",
                toaster: "b-toaster-bottom-left",
              });
              this.closeDialog();
            }
          });
        } else {
          moveTaskToColumn({
            data: {
              taskId: this.id,
              columnId: this.transferModel.taskDone
                ? 0
                : this.transferModel.columnId,
              users: this.transferModel.users,
              tsoholt: this.primaryTsoholt
                ? this.transferModel.tsoholt
                : this.hasAcceptTask.taskDescEn,
              date: this.timeData.colDate,
            },
            store: this.$store,
          }).then((res) => {
            //console.log("ene bn 11111")
            if (res != false) {
              //console.log("ene bn 2122222")
              this.$bvToast.toast(
                `Амжилттай ${mode == 0 ? "дуусгалаа" : "шилжүүллээ"}`,
                {
                  title: "Мэдэгдэл",
                  autoHideDelay: 5000,
                  appendToast: true,
                  variant: "success",
                  toaster: "b-toaster-bottom-left",
                }
              );

              if (this.hasAcceptColumn) {
                getInheritedTask({
                  params: { id: this.id },
                  store: this.$store,
                }).then((res) => {
                  if (res != false) {
                    this.getInheritedRaw = res.data.task;
                    this.getInheritedRaw.dueDate = this.hasAcceptTask.dueDate;
                    this.getInheritedRaw.taskDescEn =
                      this.hasAcceptTask.taskDescEn;
                    this.getInheritedRaw.isTender = this.hasAcceptTask.isTender;

                    postInheritedTask({
                      data: { model: this.getInheritedRaw },
                      store: this.$store,
                    }).then((res) => {
                      if (res != false) {
                        this.$bvToast.toast(`Цохолт амжилттай хадгаллаа`, {
                          title: "Мэдэгдэл",
                          autoHideDelay: 5000,
                          appendToast: true,
                          variant: "success",
                          toaster: "b-toaster-bottom-left",
                        });

                        this.closeDialog(true);
                      } else {
                        this.closeDialog();
                      }
                    });
                  }
                });
              } else {
                this.closeDialog();
              }
            } else {
              //this.closeDialog();
            }
          });
        }
        //   }
      } else {
        this.$bvToast.toast(`${errs[0]}`, {
          title: "Алдаа",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger",
          toaster: "b-toaster-bottom-left",
        });
      }
    },
  },
  computed: {
    taskId() {
      return this.id;
    },
  },
  watch: {
    taskId(val) {
      if (val > 0) {
        this.init();
      }
    },
  },
};
</script>
